module.exports = __webpack_public_path__ + "static/bibiana_fundas-8836ecc87455ad403a83fe88d7f7c4d9.mp4";